import { Component, Prop, Vue } from 'vue-property-decorator'
import Event from '@/components/shared/event/Event.vue'

@Component({
  components: { Event }
})
export default class ShowEvent extends Vue {
}
